import Logo from 'atoms/Logo';
import CardIcon from 'molecules/CardIcon';
import TimeLine from 'molecules/Timeline';
import PropTypes from 'prop-types';

/**
 * Onboarding step list — used in desktop sidebar and mobile slide-over.
 */
const SettingsStepsSidebar = ({
  timeLineListData,
  onClose,
  compact = false,
  showCardIcon = true,
  className = '',
}) => (
  <div className={`flex flex-col h-full min-h-0 ${className}`}>
    <div className={`flex items-start justify-between gap-2 shrink-0 ${compact ? 'mb-3' : 'mb-4'}`}>
      <Logo
        src="/images/aftoLogoBlue.svg"
        alt="Afto"
        className={compact ? 'w-12 h-8 flex-shrink-0' : 'w-[74px] h-[52px] flex-shrink-0 mb-2'}
      />
      {onClose ? (
        <button
          type="button"
          onClick={onClose}
          className="md:hidden shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-secondary-600 hover:bg-secondary-50"
          aria-label="Close menu"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      ) : null}
    </div>

    <div className="flex-1 min-h-0 overflow-y-auto">
      <TimeLine timeLineListData={timeLineListData} compact={compact} />
    </div>

    {showCardIcon ? (
      <div className="shrink-0 pt-3 hidden sm:block">
        <CardIcon className="mx-auto" type="forOnboarding" />
      </div>
    ) : null}
  </div>
);

SettingsStepsSidebar.propTypes = {
  timeLineListData: PropTypes.array.isRequired,
  onClose: PropTypes.func,
  compact: PropTypes.bool,
  showCardIcon: PropTypes.bool,
  className: PropTypes.string,
};

export default SettingsStepsSidebar;
